import {commonConfirmationBulkDelete} from "../../../../hoc/commonConfirmationBulkDelete";

const BulkPurchaseDelete = commonConfirmationBulkDelete("BulkPurchaseDelete");
export default BulkPurchaseDelete
